import React, { FC, useState } from 'react'

import moment from 'moment/moment'

import { CardWrapper } from '../CardWrapper/CardWrapper'
import { CardItem } from '../CardItem/CardItem'

import { IHorseData } from '../../../../../../models/horse/horse.interface'
import { IHorsesWithPaperwork } from '../../tabs/HorsesTab/HorsesTab'

import { useProfile } from '../../../../../../hooks/useProfile'

import { horseBreedList } from '../../../../../../fakeData/horseBreedList'
import { SexRestOptions } from '../../../../../customStyles/ReactSelectCustomStyle'
import { horseColorList } from '../../../../../../fakeData/horseColorList'
import { horseMarkingList } from '../../../../../../fakeData/horseMarkingList'
import { CountryList } from '../../../../../../fakeData/countryList'

interface HorseProfileCardProps {
  index: number
  horse: IHorseData
  horsesWithPaperwork: IHorsesWithPaperwork[]
  setHorsesWithPaperwork: (state: IHorsesWithPaperwork[]) => void
  isEditable?: boolean
}

export const HorseProfileCard: FC<HorseProfileCardProps> = ({
  index,
  horse,
  horsesWithPaperwork,
  setHorsesWithPaperwork,
  isEditable,
}) => {
  const { onSaveEditHorse, onCancelEditHorse, onChangeHorseInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)

  return (
    <CardWrapper
      title="Profile"
      onSaveEdit={() => onSaveEditHorse({ index, horsesWithPaperwork, setIsEdit })}
      onCancelEdit={() =>
        onCancelEditHorse({ index, horsesWithPaperwork, setHorsesWithPaperwork, setIsEdit })
      }
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        fieldType="text"
        fieldKey="horseName"
        label="Name"
        defaultValue={horse.horseName || null}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="select"
        fieldKey="horseHeight"
        label="Height"
        defaultValue={`${horse.horseHeight} h`}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="select"
        fieldKey="horseBreed"
        label="Breed"
        defaultValue={horseBreedList
          .filter((item) => horse.horseBreed?.includes(item.value))
          .map((item) => item.label)
          .join(', ')}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="date"
        fieldKey="horseDob"
        label="Date of birth"
        defaultValue={moment(horse.horseDob).format('D MMM, YYYY')}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="select"
        fieldKey="horseGender"
        label="Gender"
        defaultValue={
          SexRestOptions.find((curr) => curr.value === horse.horseGender)?.label as string
        }
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="select"
        fieldKey="horseColor"
        label="Coloring"
        defaultValue={
          horseColorList.find((curr) => curr.value === horse.horseColor)?.label as string
        }
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="select"
        fieldKey="horseMarking"
        label="Markings"
        defaultValue={horseMarkingList
          .filter((item) => horse.horseMarking?.includes(item.value))
          .map((item) => item.label)
          .join(', ')}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
      <CardItem
        fieldType="select"
        fieldKey="horseCountry"
        label="Country of origin"
        defaultValue={
          CountryList.find((curr) => curr.value === horse.horseCountry)?.label as string
        }
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeHorseInput({
            fieldName,
            fieldType,
            fieldKey,
            option,
            index,
            horsesWithPaperwork,
            setHorsesWithPaperwork,
          })
        }
      />
    </CardWrapper>
  )
}
